import { checkUUID } from "@/service/user";
import { wxLogin, qrCodeStatus } from "@/service/wx";
import { changeI18nLanguage, isMobile } from "@/utils/util.js";
import { mapMutations } from "vuex";
import dd from "dingtalk-jsapi";

// import Footer from "../components/Layout/Footer.vue";
export default {
  components: {
    // Footer,
  },
  data() {
    return {
      mobile: true,
      title: "",
      uuid: "",
      currentYear: new Date().getFullYear()
    };
  },
  methods: {
    ...mapMutations(["setLanguage"]),
    async cancle() {
      const res = await qrCodeStatus({
        uuid: this.uuid,
        status: "SCAN_CANCEL"
      });
      if (res.data.result === 0) {
        this.close();
      } else {
        this.$Message.error({
          content: res.data.msg
        });
      }
      // SCANED_LOGIN
    },
    async login() {
      const {
        uuid
      } = this.$route.query;
      const res = await wxLogin({
        uuid,
        mode: "LOGIN_CONFIRM"
      });
      if (res.data.result === 0) {
        if (res.data.retVal.status === "SCAN_CONFIRM") {
          this.$Message.success({
            content: $t("sy8ncv6", "确认登录成功")
          });
          this.close();
        } else {
          this.$Message.error({
            content: res.data.msg
          });
        }
      }
    },
    close() {
      try {
        /* eslint-disable*/
        setTimeout(function () {
          // 钉钉类页面退出
          if (dd.env.platform != "notInDingTalk") {
            dd.closePage();
          }
          // 微信类安卓系统退出
          if (window.WeixinJSBridge) {
            document.addEventListener("WeixinJSBridgeReady", function () {
              WeixinJSBridge.call("closeWindow");
            }, false);
            // 微信类ios系统的手机退出
            WeixinJSBridge && WeixinJSBridge.call("closeWindow");
          }
          if (window.h5sdk) {
            window.h5sdk.ready(() => {
              // 飞书退出
              tt.closeWindow();
            });
          }
        });
      } catch (error) {}
    }
  },
  async mounted() {
    const {
      uuid,
      title,
      language
    } = this.$route.query;
    const res = await checkUUID(uuid);
    if (res.success) {
      var _res$data, _res$data2;
      this.uuid = uuid;
      console.log(res.data.retVal);
      this.title = title || (res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.retVal) === null || _res$data === void 0 ? void 0 : _res$data.title) || "iWork";
      const language1 = (res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 || (_res$data2 = _res$data2.retVal) === null || _res$data2 === void 0 ? void 0 : _res$data2.language) || "zh-CN";
      // 路由语言优先于接口返回值，并同步 gc-i18n 与页面状态。
      const languageCode = await changeI18nLanguage(language || language1);
      if (languageCode) {
        this.setLanguage(languageCode);
      }
      document.title = this.title;

      //刷新页面 防止多次刷新
      // if (location.href.indexOf("#reloaded") == -1) {
      //   location.href = location.href + "#reloaded";
      //   location.reload();
      // }
      if (!isMobile()) {
        //pc端不用确认 直接登录
        this.mobile = false;
        this.login();
      }
    }
  }
};